<template>
  <a-modal
    ref="createModal"
    title="查看阶段详情"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    :footer="null"
  >
    <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
      <a-row>
        <a-col :md="8" :sm="24">
          <a-form-item label="序号" class="code-select">
            <a-input v-model="queryParams.stageNumber" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-item label="阶段名称">
            <a-input v-model="queryParams.stageCodeName" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="8" :sm="24">
          <a-form-item label="说明" class="itemcode">
            <a-input v-model="queryParams.remark" disabled />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="8" :sm="24">
          <a-form-item label="必须步骤">
            <a-switch :checked="queryParams.necessaryFlag === 'Y'" disabled />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="table-title">阶段详情</div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="tableList"
      :loading="pageParams.tableLoading"
      :pagination="false"
      row-key="id"
      :scroll="{ y: 235 }"
    >
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.type === 'switch'">
            <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusOnChange(record, item.dataIndex)" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
    <Page v-show="false" ref="pageModal" :pageParams.sync="pageParams" @getList="getList" />
  </a-modal>
</template>

<script>
import { apiScpMrpPlanStagesDetail } from '@/api/scp/producing-and-marketing/data-collection'
// 表单字段
export default {
  props: {},
  data () {
    return {
      pageParams: {
        automatic: false,
        pageUrl: '/scp/scpMrpPlanStagesDetail/list',
        tableLoading: false,
        pageSize: 10000
      },
      visible: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'stageNumber'
        },
        {
          title: '执行内容',
          dataIndex: 'content'
        },
        {
          title: '说明',
          dataIndex: 'remark'
        },
        {
          title: '启用',
          dataIndex: 'enableFlag',
          scopedSlots: { customRender: 'enableFlag' },
          type: "switch"
        }
      ],
      queryParams: {
        stageNumber: undefined,
        stageCodeName: undefined,
        remark: undefined,
        necessaryFlag: undefined
      },
      tableList: [],
      params: {
        stageId: ""
      }
    }
  },
  created () {},
  methods: {
    show (val) {
      this.visible = true
      this.queryParams = val
      this.params.stageId = val.id
      this.$refs.pageModal.getFirstPage(this.params)
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
      // 调用外部刷新列表方法
      this.$emit('handle-success')
    },
    // 表单重置
    reset () {
      this.tableList = []
      this.queryParams = {
        stageNumber: undefined,
        stageCodeName: undefined,
        remark: undefined,
        necessaryFlag: undefined
      }
    },
    statusOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
      apiScpMrpPlanStagesDetail(record).then(response => {
        if (response.code === 200) {
          this.$message.success('修改成功')
        } else {
          this.$message.error(response.msg)
        }
        this.$refs.pageModal.getFirstPage(this.params)
      }).catch(e => {
        this.$refs.pageModal.getFirstPage(this.params)
      })
    },
    /** 查询列表 */
    getList (data) {
      this.tableList = data
    }
  }
}
</script>

<style scoped lang="less">
input {
  width: 150px;
}
/deep/.ant-modal-body {
  height: 450px;
  overflow-y: scroll;
}
.table-title {
  font-weight: bold;
  padding: 5px 0;
}
</style>
